export const resolveLocationFromState = (location: any): string => {
  if (location.state?.from) {
    const fromPath = `${location.state.from.pathname}${location.state.from.search || ''}`;
    if (['/login', '/login/callback', '/logout'].includes(fromPath)) {
      return '/';
    }
    return fromPath;
  }
  return '/';
};

